<template>
  <b-container>
    <!-- Cообщения -->
    <div id="app-msgs" class="container"></div>

    <b-row id="content" align-h="between">
      <b-col cols="12">
        <div class="text-center">
          <div class="icon mb-3"></div>
          <h1>{{ $t('verification.token.success.h') }}</h1>
          <div class="text-secondary mb-5">{{ $t('verification.token.success.p') }}</div>
          <b-button variant="primary" @click="handleClick">{{ $t('button.continue') }}</b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "VerificationSuccess",
  methods: {
    handleClick() {
      if (this.$store.getters.isAdmin) {
        this.$router.push('/admin');
      } else {
        this.$router.push('/dashboard');
      }
    },
  },
};
</script>

<style scoped>
.icon {
  min-width: 150px;
  min-height: 150px;
  background-image: url(/success.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>